/**
 * the scope a constant definition is attached to
 *
 * system constants override organization constants when keynames collide
 */
export enum ConstantScope {
  Organization = "organization",
  System = "system",
}
